/**
 * Musetopia Order & Logistics Tracking Component
 * Fully Internationalized (i18n) via Shopify locales JSON
 */
(function () {
  'use strict';

  var BADGE_CLASS_MAP = {
    'DELIVERED': 'status-delivered',
    'OUT_FOR_DELIVERY': 'status-out_for_delivery',
    'IN_TRANSIT': 'status-in_transit',
    'CONFIRMED': 'status-confirmed',
    'DELAYED': 'status-delayed',
    'LABEL_CREATED': 'status-label_created',
    'READY_FOR_PICKUP': 'status-ready_for_pickup',
    'EXCEPTION': 'status-exception',
    'FAILURE': 'status-failure',
    'ATTEMPTED_DELIVERY': 'status-failure',
    'DEFAULT': 'status-order_processed'
  };

  function formatDisplayTime(rawTime) {
    if (!rawTime) return '';
    try {
      var d = new Date(rawTime);
      if (isNaN(d.getTime()) && typeof rawTime === 'string') {
        d = new Date(rawTime.replace(/-/g, '/'));
      }
      if (isNaN(d.getTime())) return rawTime;
      return d.toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
      });
    } catch (e) {
      return rawTime;
    }
  }

  function getMockEvents(trackingNo, carrier) {
    var now = new Date();
    function offsetHours(h) {
      var t = new Date(now.getTime() - h * 3600 * 1000);
      return t.toISOString().replace('T', ' ').substring(0, 19);
    }

    return [
      {
        event_time: offsetHours(4),
        event_location: 'Los Angeles, CA, United States',
        event_desc: 'Departed from local distribution center, in transit to destination sorting facility',
        logistics_status: 'IN_TRANSIT'
      },
      {
        event_time: offsetHours(18),
        event_location: 'Los Angeles International Airport, CA',
        event_desc: 'Customs clearance completed successfully',
        logistics_status: 'IN_TRANSIT'
      },
      {
        event_time: offsetHours(36),
        event_location: 'In Flight',
        event_desc: 'Flight departed from origin country/region',
        logistics_status: 'IN_TRANSIT'
      },
      {
        event_time: offsetHours(60),
        event_location: 'Shenzhen Sort Facility, China',
        event_desc: 'Package processed and dispatched from sorting hub',
        logistics_status: 'IN_TRANSIT'
      },
      {
        event_time: offsetHours(74),
        event_location: 'Shenzhen, China',
        event_desc: 'Carrier received shipping info and picked up parcel',
        logistics_status: 'LABEL_CREATED'
      }
    ];
  }

  function initTrackOrder(container) {
    if (!container || container.__trackOrderInited) return;
    container.__trackOrderInited = true;

    // Load i18n JSON
    var i18n = {};
    var i18nEl = container.querySelector('script[id^="TrackOrderI18n-"]');
    if (i18nEl) {
      try {
        i18n = JSON.parse(i18nEl.textContent);
      } catch (e) {
        console.warn('[Track Order] Failed to parse i18n dictionary:', e);
      }
    }

    function t(path, fallback, replacements) {
      var parts = path.split('.');
      var curr = i18n;
      for (var i = 0; i < parts.length; i++) {
        if (curr && typeof curr === 'object' && parts[i] in curr) {
          curr = curr[parts[i]];
        } else {
          curr = null;
          break;
        }
      }
      var str = (curr !== null && curr !== undefined && curr !== '') ? String(curr) : (fallback || '');
      if (replacements && typeof replacements === 'object') {
        Object.keys(replacements).forEach(function (k) {
          str = str.replace(new RegExp('{{\\s*' + k + '\\s*}}', 'g'), replacements[k]);
        });
      }
      return str;
    }

    var apiBaseUrl = (container.getAttribute('data-api-base-url') || '').trim();
    var authToken = (container.getAttribute('data-auth-token') || '').trim();
    var clientCode = (container.getAttribute('data-client-code') || '').trim();
    var apiKey = (container.getAttribute('data-api-key') || '').trim();

    var tabs = container.querySelectorAll('[data-track-tab]');
    var form = container.querySelector('[data-track-form]');
    var input = container.querySelector('[data-track-input]');
    var clearBtn = container.querySelector('[data-track-clear]');
    var submitBtn = container.querySelector('[data-track-submit]');
    var resultsWrap = container.querySelector('[data-track-results]');
    var alertCard = container.querySelector('[data-alert-card]');
    var alertTitle = container.querySelector('[data-alert-title]');
    var alertText = container.querySelector('[data-alert-text]');

    var statusBanner = container.querySelector('[data-status-banner]');
    var statusBadge = container.querySelector('[data-status-badge]');
    var statusTitle = container.querySelector('[data-status-title]');
    var statusDesc = container.querySelector('[data-status-desc]');

    var packagesNav = container.querySelector('[data-packages-nav]');
    var detailCard = container.querySelector('[data-detail-card]');
    var carrierNameEl = container.querySelector('[data-carrier-name]');
    var trackingNoEl = container.querySelector('[data-tracking-no]');
    var copyBtn = container.querySelector('[data-copy-btn]');
    var timelineList = container.querySelector('[data-timeline]');

    var currentMode = 'tracking'; // 'tracking' | 'order'
    var currentPackages = [];
    var activePackageIndex = 0;

    function getStatusInfo(statusKey) {
      var normalized = statusKey ? String(statusKey).toUpperCase().trim() : 'DEFAULT';
      var badgeClass = BADGE_CLASS_MAP[normalized] || BADGE_CLASS_MAP['DEFAULT'];

      var title = t('status.' + normalized + '.title', '');
      var desc = t('status.' + normalized + '.desc', '');

      if (!title) {
        title = t('status.DEFAULT.title', 'Order Processed');
        desc = t('status.DEFAULT.desc', 'Tracking details will be updated once scanned by the carrier.');
      }

      return {
        title: title,
        desc: desc,
        badgeClass: badgeClass
      };
    }

    function resetResults() {
      if (resultsWrap) resultsWrap.style.display = 'none';
      if (alertCard) alertCard.style.display = 'none';
      if (packagesNav) {
        packagesNav.innerHTML = '';
        packagesNav.style.display = 'none';
      }
      currentPackages = [];
      activePackageIndex = 0;
    }

    function setMode(mode, isUserInteraction) {
      currentMode = mode;
      tabs.forEach(function (tab) {
        var tabMode = tab.getAttribute('data-track-tab');
        var isActive = tabMode === mode;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (mode === 'order') {
        input.placeholder = t('placeholderOrder', 'e.g. #1001 or 1001');
      } else {
        input.placeholder = t('placeholderTracking', 'e.g. YT2624900705902339');
      }

      if (isUserInteraction) {
        if (input) {
          input.value = '';
        }
        if (clearBtn) {
          clearBtn.style.display = 'none';
        }
        resetResults();
      }

      if (input) {
        input.focus();
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var mode = tab.getAttribute('data-track-tab');
        if (mode && mode !== currentMode) {
          setMode(mode, true);
        }
      });
    });

    if (input) {
      input.addEventListener('input', function () {
        if (clearBtn) {
          clearBtn.style.display = input.value.trim() ? 'inline-flex' : 'none';
        }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        clearBtn.style.display = 'none';
        input.focus();
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var trackingNo = (trackingNoEl && trackingNoEl.textContent) ? trackingNoEl.textContent.trim() : '';
        if (!trackingNo) return;

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(trackingNo).then(onCopied).catch(fallbackCopy);
        } else {
          fallbackCopy();
        }

        function fallbackCopy() {
          var tempInput = document.createElement('input');
          tempInput.value = trackingNo;
          document.body.appendChild(tempInput);
          tempInput.select();
          document.execCommand('copy');
          document.body.removeChild(tempInput);
          onCopied();
        }

        function onCopied() {
          var originalLabel = t('copy', 'Copy');
          var copiedLabel = t('copied', 'Copied!');
          copyBtn.classList.add('is-copied');
          copyBtn.innerHTML =
            '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
              '<polyline points="20 6 9 17 4 12"></polyline>' +
            '</svg> ' +
            '<span>' + copiedLabel + '</span>';

          setTimeout(function () {
            copyBtn.classList.remove('is-copied');
            copyBtn.innerHTML =
              '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>' +
                '<path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>' +
              '</svg> ' +
              '<span>' + originalLabel + '</span>';
          }, 2000);
        }
      });
    }

    function setLoading(isLoading) {
      if (!submitBtn) return;
      submitBtn.disabled = isLoading;
      submitBtn.classList.toggle('is-loading', isLoading);
      var btnText = submitBtn.querySelector('[data-btn-text]');
      if (btnText) {
        btnText.textContent = isLoading
          ? t('btnTracking', 'Tracking...')
          : t('btnTrack', 'Track');
      }
    }

    function showAlert(title, message) {
      if (resultsWrap) resultsWrap.style.display = 'none';
      if (alertCard) {
        if (alertTitle) alertTitle.textContent = title;
        if (alertText) alertText.textContent = message;
        alertCard.style.display = 'block';
      }
    }

    function hideAlert() {
      if (alertCard) alertCard.style.display = 'none';
    }

    function renderPackage(pkg) {
      if (!pkg) return;

      var statusInfo = getStatusInfo(pkg.logistics_status);

      // Render Status Banner
      if (statusBadge) {
        statusBadge.className = 'track-status-badge ' + statusInfo.badgeClass;
        statusBadge.textContent = statusInfo.title;
      }
      if (statusTitle) statusTitle.textContent = statusInfo.title;
      if (statusDesc) statusDesc.textContent = statusInfo.desc;
      if (statusBanner) statusBanner.style.display = 'block';

      // Header info
      if (carrierNameEl) {
        carrierNameEl.textContent = pkg.carrier_name || t('carrierPartner', 'Carrier Partner');
      }
      if (trackingNoEl) {
        trackingNoEl.textContent = pkg.tracking_no || '-';
      }

      // Render Timeline
      if (timelineList) {
        timelineList.innerHTML = '';
        var events = pkg.tracking_events || [];

        if (events.length === 0) {
          var emptyItem = document.createElement('li');
          emptyItem.className = 'track-event-item';
          var noEventsDesc = t('status.noEventsDesc', 'Tracking information has not yet been updated. Please check back later.');
          emptyItem.innerHTML =
            '<div class="track-event-dot"></div>' +
            '<div class="track-event-content">' +
              '<div class="track-event-desc" style="color: #777;">' + noEventsDesc + '</div>' +
            '</div>';
          timelineList.appendChild(emptyItem);
        } else {
          events.forEach(function (ev, index) {
            var item = document.createElement('li');
            item.className = 'track-event-item';

            var timeHtml = ev.event_time ? '<div class="track-event-time">' + formatDisplayTime(ev.event_time) + '</div>' : '';
            var descHtml = '<div class="track-event-desc">' + (ev.event_desc || statusInfo.title) + '</div>';
            var locHtml = ev.event_location
              ? '<div class="track-event-loc">' +
                  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                    '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>' +
                    '<circle cx="12" cy="10" r="3"></circle>' +
                  '</svg>' +
                  '<span>' + ev.event_location + '</span>' +
                '</div>'
              : '';

            item.innerHTML =
              '<div class="track-event-dot"></div>' +
              '<div class="track-event-content">' +
                timeHtml +
                descHtml +
                locHtml +
              '</div>';

            timelineList.appendChild(item);
          });
        }
      }

      if (detailCard) detailCard.style.display = 'block';
      if (resultsWrap) resultsWrap.style.display = 'block';
    }

    function renderPackagesList(packagesList) {
      currentPackages = packagesList || [];
      activePackageIndex = 0;

      if (!packagesNav) return;

      if (currentPackages.length > 1) {
        packagesNav.innerHTML = '';
        currentPackages.forEach(function (pkg, idx) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'track-pkg-tab' + (idx === 0 ? ' is-active' : '');
          btn.textContent = t('packagePill', 'Package {{ current }} of {{ total }}', {
            current: idx + 1,
            total: currentPackages.length
          });
          btn.addEventListener('click', function () {
            packagesNav.querySelectorAll('.track-pkg-tab').forEach(function (b) {
              b.classList.remove('is-active');
            });
            btn.classList.add('is-active');
            activePackageIndex = idx;
            renderPackage(currentPackages[idx]);
          });
          packagesNav.appendChild(btn);
        });
        packagesNav.style.display = 'flex';
      } else {
        packagesNav.innerHTML = '';
        packagesNav.style.display = 'none';
      }

      if (currentPackages.length > 0) {
        renderPackage(currentPackages[0]);
      } else {
        showAlert(
          t('errors.notFoundTitle', 'No Records Found'),
          t('errors.notFoundDesc', 'Please check your tracking or order number. Updates may take 24-48 hours to appear after fulfillment.')
        );
      }
    }

    // API Query Handler
    function executeQuery(queryValue, mode) {
      var cleanValue = (queryValue || '').trim();
      if (!cleanValue) {
        showAlert(
          t('errors.inputRequired', 'Input Required'),
          t('errors.inputRequired', 'Please enter a valid order number or tracking number.')
        );
        return;
      }

      hideAlert();
      setLoading(true);
      // Ensure order number always has '#' prefix
      if (mode === 'order') {
        if (cleanValue.indexOf('#') !== 0) {
          cleanValue = '#' + cleanValue;
        } else {
          cleanValue = '#' + cleanValue.substring(1).trim();
        }
      }

      var isOrderQuery = mode === 'order';
      var endpointPath = isOrderQuery
        ? '/ofp-order-service/openapi/track/query/getLogisticsByShopifyOrderNo'
        : '/ofp-order-service/openapi/track/query/getTrackingByLogisticsNo';

      var requestBody = isOrderQuery
        ? { shopify_order_no: cleanValue }
        : { tracking_no: cleanValue };

      // Check if real API base URL is configured
      if (!apiBaseUrl) {
        // Mock fallback for immediate preview and testing
        setTimeout(function () {
          setLoading(false);
          var mockCarrier = 'YunExpress';
          var mockEvents = getMockEvents(cleanValue, mockCarrier);

          if (isOrderQuery) {
            var mockResp = {
              shopify_order_no: cleanValue,
              logistics_list: [
                {
                  tracking_no: 'YT' + (cleanValue.length > 5 ? cleanValue : '2624900705902339'),
                  carrier_name: mockCarrier,
                  logistics_status: 'IN_TRANSIT',
                  tracking_events: mockEvents
                }
              ]
            };
            renderPackagesList(mockResp.logistics_list);
          } else {
            var mockItem = {
              tracking_no: cleanValue,
              carrier_name: mockCarrier,
              logistics_status: 'IN_TRANSIT',
              tracking_events: mockEvents
            };
            renderPackagesList([mockItem]);
          }
        }, 600);
        return;
      }

      // Real API Call
      var fullUrl = apiBaseUrl.replace(/\/+$/, '') + endpointPath;
      var headers = {
        'Content-Type': 'application/json'
      };
      if (authToken) headers['Authorization'] = authToken;
      if (clientCode) headers['Client-Code'] = clientCode;
      if (apiKey) headers['X-Api-Key'] = apiKey;

      fetch(fullUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(requestBody)
      })
        .then(function (res) {
          if (!res.ok) {
            throw new Error('Network response was not ok (' + res.status + ')');
          }
          return res.json();
        })
        .then(function (resData) {
          setLoading(false);
          if (resData && (resData.successful === true || resData.code === 200 || resData.code === 0)) {
            var payload = resData.data;
            if (!payload) {
              showAlert(
                t('errors.notFoundTitle', 'No Records Found'),
                t('errors.notFoundDesc', 'No tracking record found for this number.')
              );
              return;
            }

            if (isOrderQuery) {
              renderPackagesList(payload.logistics_list || []);
            } else {
              renderPackagesList([payload]);
            }
          } else {
            var errMsg = (resData && resData.message)
              ? resData.message
              : t('errors.notFoundDesc', 'Unable to find tracking records.');
            showAlert(t('errors.notFoundTitle', 'Tracking Record Not Found'), errMsg);
          }
        })
        .catch(function (err) {
          console.warn('[Track Order] API request error:', err);
          setLoading(false);
          showAlert(
            t('errors.serviceUnavailableTitle', 'Service Temporarily Unavailable'),
            t('errors.serviceUnavailableDesc', 'Unable to fetch tracking info at this time. Please check your tracking number and try again in a few minutes.')
          );
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var val = input ? input.value : '';
        executeQuery(val, currentMode);
      });
    }

    // Auto-query from URL parameters
    function handleUrlParams() {
      try {
        var params = new URLSearchParams(window.location.search);
        var trackingParam = params.get('nums') || params.get('tracking_no') || params.get('trackingNo');
        var orderParam = params.get('order_no') || params.get('orderNo');

        if (trackingParam) {
          setMode('tracking');
          if (input) {
            input.value = trackingParam.trim();
            if (clearBtn) clearBtn.style.display = 'inline-flex';
          }
          executeQuery(trackingParam, 'tracking');
        } else if (orderParam) {
          setMode('order');
          if (input) {
            input.value = orderParam.trim();
            if (clearBtn) clearBtn.style.display = 'inline-flex';
          }
          executeQuery(orderParam, 'order');
        }
      } catch (e) {
        console.warn('[Track Order] URL params parse error:', e);
      }
    }

    handleUrlParams();
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-track-order-section]');
    sections.forEach(function (sec) {
      initTrackOrder(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Support Shopify Theme Editor dynamic section reload
  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target.querySelector('[data-track-order-section]') || e.target;
    if (target && target.matches && target.matches('[data-track-order-section]')) {
      initTrackOrder(target);
    }
  });
})();
